import axios from 'axios';

export default {
  getToken() {
    return localStorage.getItem('user-token');
  },
  async exportCovenantsXls(params = {}) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/covenants/export`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params,
          responseType: 'arraybuffer',
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getCovenants(params = {}) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/covenants-filtered`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params,
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};
